<div class="breadcrumb-container">
  <div class="flex flex-row justify-start items-center" [hidden]="isLanding()">
    @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index; let isLast = $last) {
      <div>
        @if (!breadcrumb.pauseDisplay) {
          <span [ngClass]="!isLast ? 'breadcrumb-history-link' : 'breadcrumb-last-element'" (click)="routeTo(i)">{{
            breadcrumb.name
          }}</span>
          @if (!isLast) {
            <span> <mat-icon>keyboard_arrow_right</mat-icon> </span>
          }
        }
      </div>
    }
  </div>
</div>
